/**
 *  @hidden
 */
export var load = 'load';
/** @hidden */
export var rowDataBound = 'rowDataBound';
/** @hidden */
export var dataBound = 'dataBound';
/** @hidden */
export var queryCellInfo = 'queryCellInfo';
/** @hidden */
export var beforeDataBound = 'beforeDataBound';
/** @hidden */
export var actionBegin = 'actionBegin';
/** @hidden */
export var dataStateChange = 'dataStateChange';
/** @hidden */
export var actionComplete = 'actionComplete';
/** @hidden */
export var rowSelecting = 'rowSelecting';
/** @hidden */
export var rowSelected = 'rowSelected';
/** @hidden */
export var checkboxChange = 'checkboxChange';
/** @hidden */
export var rowDeselected = 'rowDeselected';
/** @hidden */
export var toolbarClick = 'toolbarClick';
/** @hidden */
export var beforeExcelExport = 'beforeExcelExport';
/** @hidden */
export var beforePdfExport = 'beforePdfExport';
/** @hidden */
export var resizeStop = 'resizeStop';
/** @hidden */
export var expanded = 'expanded';
/** @hidden */
export var expanding = 'expanding';
/** @hidden */
export var collapsed = 'collapsed';
/** @hidden */
export var collapsing = 'collapsing';
/** @hidden */
export var remoteExpand = 'remoteExpand';
/** @hidden */
export var localPagedExpandCollapse = 'localPagedExpandCollapse';
/** @hidden */
export var pagingActions = 'pagingActions';
/** @hidden */
export var printGridInit = 'printGrid-Init';
/** @hidden */
export var contextMenuOpen = 'contextMenuOpen';
/** @hidden */
export var contextMenuClick = 'contextMenuClick';
/** @hidden */
export var beforeCopy = 'beforeCopy';
/** @hidden */
export var beforePaste = 'beforePaste';
/** @hidden */
export var savePreviousRowPosition = 'savePreviousRowPosition';
/** @hidden */
export var crudAction = 'crudAction';
/** @hidden */
export var beginEdit = 'beginEdit';
/** @hidden */
export var beginAdd = 'beginAdd';
/** @hidden */
export var recordDoubleClick = 'recordDoubleClick';
/** @hidden */
export var cellSave = 'cellSave';
/** @hidden */
export var cellSaved = 'cellSaved';
/** @hidden */
export var cellEdit = 'cellEdit';
/** @hidden */
export var batchDelete = 'batchDelete';
/** @hidden */
export var batchCancel = 'batchCancel';
/** @hidden */
export var batchAdd = 'batchAdd';
/** @hidden */
export var beforeBatchDelete = 'beforeBatchDelete';
/** @hidden */
export var beforeBatchAdd = 'beforeBatchAdd';
/** @hidden */
export var beforeBatchSave = 'beforeBatchSave';
/** @hidden */
export var batchSave = 'batchSave';
/** @hidden */
export var keyPressed = 'key-pressed';
/** @hidden */
export var updateData = 'update-data';
/** @hidden */
export var doubleTap = 'double-tap';
/** @hidden */
export var virtualColumnIndex = 'virtualColumnIndex';
/** @hidden */
export var virtualActionArgs = 'virtual-action-args';
/** @hidden */
export var dataListener = 'data-listener';
/** @hidden */
export var indexModifier = 'index-modifier';
/** @hidden */
export var beforeStartEdit = 'edit-form';
/** @hidden */
export var beforeBatchCancel = 'before-batch-cancel';
/** @hidden */
export var batchEditFormRendered = 'batcheditform-rendered';
/** @hidden */
export var detailDataBound = 'detailDataBound';
/** @hidden */
export var rowDrag = 'rowDrag';
/** @hidden */
export var rowDragStartHelper = 'rowDragStartHelper';
/** @hidden */
export var rowDrop = 'rowDrop';
/** @hidden */
export var rowDragStart = 'rowDragStart';
/** @hidden */
export var rowsAdd = 'rows-add';
/** @hidden */
export var rowsRemove = 'rows-remove';
/** @hidden */
export var rowdraging = 'row-draging';
/** @hidden */
export var rowDropped = 'row-dropped';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-treegrid/src/treegrid/base/constant.js
// module id = null
// module chunks = 